module.exports = __webpack_public_path__ + "img/stryker_logo_small.91d6d18c.png";